import { useMemo } from 'react'

import ComplexDialogHistory from 'Components/UI/Molecules/ComplexDialogHistory'

const HistorialContent = (props) => {
  const { data } = props

  const history = useMemo(() => {
    if (Array.isArray(data?.history)) return data.history
    return []
  }, [data])

  return <ComplexDialogHistory history={history} />
}

export default HistorialContent
